// extracted by mini-css-extract-plugin
export default {"wrapper":"Q_dv","option":"Q_fy"};